import AbstractMappingValidator from './abstract-mapping-validator';
import ConditionService from '../../service/mapping/condition-service';
export default class ConditionValidator extends AbstractMappingValidator {
    constructor() {
        super(...arguments);
        this.index = null;
        this.conditionCount = 1;
    }
    validate(condition) {
        this.errors = {};
        if (!condition) {
            return this.errors;
        }
        this.validateActions(condition, this.errors);
        if (!condition.hasValue() && !this.requiresValue()) {
            return this.errors;
        }
        this.validateValue(condition, this.errors);
        this.validateOperator(condition, this.errors);
        this.validateExpectedValue(condition, this.errors);
        return this.errors;
    }
    requiresValue() {
        if (this.conditionCount <= 1) {
            return false;
        }
        const lastIndex = this.conditionCount - 1;
        if (this.index === lastIndex) {
            return false;
        }
        return true;
    }
    validateValue(condition, validationErrors) {
        if (!condition) {
            return;
        }
        let errors = [];
        if (condition.valueSettings && Object.keys(condition.valueSettings).length) {
            errors = this.validateValueSettings(condition.valueSettings, validationErrors);
        }
        else {
            errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
        }
        if (errors.length > 0) {
            validationErrors.valueSettings = errors;
        }
    }
    validateOperator(condition, validationErrors) {
        if (!condition) {
            return;
        }
        const errors = [];
        if (!condition.operator || !ConditionService.OPERATORS.includes(condition.operator)) {
            errors.push(this.i18n.t('mapping.validation.please_select_operator').toString());
        }
        if (errors.length > 0) {
            validationErrors.operator = errors;
        }
    }
    validateExpectedValue(condition, validationErrors) {
        if (!condition) {
            return;
        }
        if (!condition.operator) {
            return;
        }
        if (ConditionService.NO_VALUE_OPERATORS.includes(condition.operator)) {
            return;
        }
        let errors = [];
        if (condition.expectedValueSettings && Object.keys(condition.expectedValueSettings).length) {
            errors = this.validateValueSettings(condition.expectedValueSettings, validationErrors);
        }
        else {
            errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
        }
        if (errors.length > 0) {
            validationErrors.expectedValueSettings = errors;
        }
    }
    validateActions(condition, validationErrors) {
        if (!condition) {
            return;
        }
        const errors = [];
        if (condition.actions.length) {
            for (const index in condition.actions) {
                const action = condition.actions[index];
                const actionValidator = action.validator;
                actionValidator.index = parseInt(index);
                if (Object.keys(actionValidator.validate(action)).length) {
                    errors.push(this.i18n.t('mapping.validation.action_invalid', { index }).toString());
                }
            }
        }
        else {
            errors.push(this.i18n.t('mapping.validation.action_required').toString());
        }
        if (errors.length > 0) {
            validationErrors.actions = errors;
        }
    }
}
//# sourceMappingURL=condition-validator.js.map